import {
    animation, state, trigger, animateChild, group,
    transition, animate, style, query
} from '@angular/animations';

export function slideIn(name: string, startingHeight: string, endingHeight: string, backgroundColor: string) {

    return trigger(name, [

        state('in', style({
            height: startingHeight + 'px',
            backgroundColor: 'white'
        })),
        state('out', style({
            height: endingHeight + 'px',
            backgroundColor: backgroundColor
        })),

        transition('out => in', animate('300ms ease-in')),
        transition('in => out', animate('300ms ease-in'))
    ]);

}

